// Single owner of the optimistic-concurrency token used by every save path
// that PUTs api/ideal-studio/training/save-state (ideaEnvSaveState in
// server_utils.es6, exportStateAsync in actions.es6) -- so the two paths
// can't drift out of sync on what the "last known" updatedAt is. Always the
// exact ISO string the server last returned, never a locally generated
// timestamp (the server compares ms-truncated Dates).
let baseUpdatedAt = null;

export function getBaseUpdatedAt() {
  return baseUpdatedAt;
}

export function setBaseUpdatedAt(value) {
  baseUpdatedAt = value || null;
}

// What a save request body should add: the known token, or nothing at all
// when forcing an overwrite (the server treats an absent field as "skip the
// check") or when there isn't a token yet.
export function buildBaseUpdatedAtField(force) {
  if (force) return {};
  const token = getBaseUpdatedAt();
  return token ? { baseUpdatedAt: token } : {};
}

// Updates the token from a successful save-state response body. Safe to
// call with any shape -- no-ops unless it actually carries a fresh
// training.updatedAt.
export function updateBaseUpdatedAtFromResponse(body) {
  const updatedAt = body && body.success && body.training && body.training.updatedAt;
  if (updatedAt) setBaseUpdatedAt(updatedAt);
  return updatedAt || null;
}

// Distinguishes a genuine 409 conflict from any other response (a success,
// the pre-existing "HTTP 200 { success: false }" failure shape, or a real
// error). Returns null unless status is 409.
export function parseSaveConflict(status, body) {
  if (status !== 409) return null;
  return { currentUpdatedAt: (body && body.currentUpdatedAt) || null };
}
